import { render, staticRenderFns } from "./BotPerformance.vue?vue&type=template&id=35332306&"
import script from "./BotPerformance.vue?vue&type=script&lang=js&"
export * from "./BotPerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports